import { fetchStrapiSingleType } from './strapiClient';

/** @returns {Promise<{title, intro, cardInfoConnection, cardSportConnection, cardExpertConnection, closing}|null>} */
export async function fetchNotreHistoireFromStrapi() {
  const attrs = await fetchStrapiSingleType('notre-histoire');
  if (!attrs) return null;
  return {
    title: attrs.title ?? '',
    intro: attrs.intro ?? '',
    cardInfoConnection: attrs.cardInfoConnection ?? '',
    cardSportConnection: attrs.cardSportConnection ?? '',
    cardExpertConnection: attrs.cardExpertConnection ?? '',
    closing: attrs.closing ?? '',
  };
}
